import { ApiCall, type ApiCallOptions } from './api.base';
import type {
  AcrylStandImageProcessingMapleCharacterResponse,
  AcrylStandImageProcessingMapleCharacterRequest,
  GenerateStickerRequest,
  GenerateStickerResponse,
  GenerateAcrylStandRequest,
  GenerateAcrylStandResponse,
  GenerateNameTagResponse,
  GenerateNameTagRequest,
  GenerateDollPrintableImageResponse,
  GenerateDollPrintableImageRequest,
} from '@modules/Vector/S/api.dto';

export class VectorAppApiCall extends ApiCall {
  constructor(options: ApiCallOptions = {}) {
    super(options);
  }

  async generateSticker(
    body: GenerateStickerRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<GenerateStickerResponse> {
    return this.post<GenerateStickerResponse>(
      '/:lang/@api/vector/sticker/generate', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async acrylStandImageProcessingMapleCharacter(
    body: AcrylStandImageProcessingMapleCharacterRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<AcrylStandImageProcessingMapleCharacterResponse> {
    return this.post<AcrylStandImageProcessingMapleCharacterResponse>(
      '/:lang/@api/vector/acryl-stand/image-processing/maple-character', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async generateAcrylStand(
    body: GenerateAcrylStandRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<GenerateAcrylStandResponse> {
    return this.post<GenerateAcrylStandResponse>(
      '/:lang/@api/vector/acryl-stand/generate', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async generateNameTag(
    body: GenerateNameTagRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<GenerateNameTagResponse> {
    return this.post<GenerateNameTagResponse>(
      '/:lang/@api/vector/name-tag/generate', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }

  async generateDollPrintableImage(
    body: GenerateDollPrintableImageRequest,
    shouldAbortPrevious?: boolean,
    headers?: Record<string, string>,
  ): Promise<GenerateDollPrintableImageResponse> {
    return this.post<GenerateDollPrintableImageResponse>(
      '/:lang/@api/vector/doll/printable/generate', // app/all/api/vector.ts
      body,
      shouldAbortPrevious,
      headers,
    );
  }
}
